import { Popup } from "components/UI/Popup";
import { BaseButton } from "components/buttons/BaseButton";
import "./UnfollowPopup.scss";

interface IUnfollowPopupProps {
  isOpen: boolean;
  togglePopup: () => void;
  handleUnfollow: () => void;
}

export const UnfollowPopup = ({ isOpen, togglePopup, handleUnfollow }: IUnfollowPopupProps) => {
  return (
    <Popup
      isOpen={isOpen}
      popupClass="UnfollowPopup"
    >
      <p>If you unfollow, content from this niche will no longer appear in your feed.</p>
      <BaseButton onClick={handleUnfollow}>Unfollow</BaseButton>
      <button onClick={togglePopup}>Cancel</button>
    </Popup >
  );
};
